import React from 'react';

import RoutePaths from 'security-app/routing/Routes';
import EventsPageNavigation from 'components/events/EventsPageNavigation';
import useLicenseCheck from 'license/useLicenseCheck';
import { EVENT_DEFINITIONS_TITLE } from 'components/events/bindings';

import EventProcedures from './index';

const EVENT_PROCEDURES_TITLE = 'Event Procedures';

export default {
  routes: [
    {
      path: RoutePaths.unqualified.CORE_EVENTS.EVENT_PROCEDURES.LIST(':viewType'),
      component: () => <EventProcedures navigationComponent={<EventsPageNavigation />} useCoreRoutes />,
    },
  ],
  'alerts.pageNavigation': [
    {
      description: EVENT_PROCEDURES_TITLE,
      path: RoutePaths.CORE_EVENTS.EVENT_PROCEDURES.LIST('procedures'),
      permissions: [],
      position: { after: EVENT_DEFINITIONS_TITLE },
      useIsValidLicense: () => {
        const {
          security: { isValid: isValidSecurityLicense },
        } = useLicenseCheck();

        return isValidSecurityLicense;
      },
    },
  ],
};
